import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SPEND_TAB_VALUES } from '@apps/web/components/admin/llm_spend/constants';
import {
    AGENT_GENERATION_VALUES,
    DEFAULT_RANGE_PRESET,
    RANGE_PRESET_VALUES,
    SPEND_MODE_VALUES,
} from '@apps/web/components/admin/llm_spend/constants';

export const Route = createFileRoute('/_app/admin/llm-spend')({
    validateSearch: z.object({
        range: z.enum(RANGE_PRESET_VALUES).catch(DEFAULT_RANGE_PRESET),
        bucket: z.enum(['day', 'week']).catch('day'),
        mode: z.enum(SPEND_MODE_VALUES).catch('live'),
        tab: z.enum(SPEND_TAB_VALUES).catch('overview'),
        generation: z.enum(AGENT_GENERATION_VALUES).catch('all'),
        // Absent means every organization; the filter applies to all tabs.
        org: z.array(z.string().uuid()).optional().catch(undefined),
        from: z
            .string()
            .regex(/^\d{4}-\d{2}-\d{2}$/)
            .optional()
            .catch(undefined),
        to: z
            .string()
            .regex(/^\d{4}-\d{2}-\d{2}$/)
            .optional()
            .catch(undefined),
        // Renders a deterministic fixture instead of the API so the page can
        // be reviewed before the rollup produces real rows.
        sample: z.boolean().optional().catch(undefined),
    }),
    head: () => ({ meta: [{ title: 'LLM Spend | Phoebe Admin' }] }),
});
